(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // =========================
    // Announcement rotator
    // =========================
    const bar = document.querySelector('.ab-announce');
    if (bar) {
      const rotate = bar.dataset.rotate === 'true';
      const interval = parseInt(bar.dataset.interval || '5000', 10);
      const items = Array.from(bar.querySelectorAll('.ab-announce__item'));

      if (rotate && items.length >= 2) {
        let idx = 0;
        setInterval(() => {
          items[idx].classList.remove('is-active');
          idx = (idx + 1) % items.length;
          items[idx].classList.add('is-active');
        }, interval);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
